function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Link } from "react-router-dom";
import { PageHeader, Switcher } from "../../components/analytics-kit";
import { hasTenantFeature } from "../../functions/tenant-features";
import { emailViews } from "./index";

// One header for every Email tab (EMAIL redesign 2026-10-09, PlunkDocs mockups/email-section-redesign-2026-10-09.html):
// the same title and line, the tabs, and one "New" menu (Campaign, Journey, Single email, Outreach).
export const EMAIL_SUBTITLE = "Campaigns you send once, journeys that run on their own, and outreach from your own mailboxes";
export function newEmailItems() {
  const items = [{
    to: "/Email/campaigns/new",
    label: "Campaign",
    sub: "One email to a list, sent now or on a date"
  }, {
    to: "/Email/journeys/new",
    label: "Journey",
    sub: "A series of emails that starts when someone does something"
  }, {
    to: "/Email/journeys/new?template=single",
    label: "Single email",
    sub: "One email that goes out when something happens"
  }];
  if (hasTenantFeature("outreach")) items.push({
    to: "/Email/campaigns/outreach/new",
    label: "Outreach",
    sub: "Personal emails to new leads from your mailboxes"
  });
  return items;
}
export class NewEmailMenu extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "outside", e => {
      if (this.state.open && this.ref.current && !this.ref.current.contains(e.target)) this.setState({
        open: false
      });
    });
    _defineProperty(this, "esc", e => {
      if (e.key === "Escape" && this.state.open) this.setState({
        open: false
      });
    });
    this.state = {
      open: false
    };
    this.ref = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.outside);
    document.addEventListener("keydown", this.esc);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.outside);
    document.removeEventListener("keydown", this.esc);
  }
  render() {
    const {
      open
    } = this.state;
    return /*#__PURE__*/React.createElement("span", {
      className: "em-new",
      ref: this.ref
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary em-new-btn",
      "aria-haspopup": "menu",
      "aria-expanded": open,
      onClick: () => this.setState({
        open: !open
      })
    }, "New ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "expand_more")), open && /*#__PURE__*/React.createElement("div", {
      className: "em-new-menu",
      role: "menu"
    }, newEmailItems().map(it => /*#__PURE__*/React.createElement(Link, {
      key: it.label,
      role: "menuitem",
      to: it.to,
      onClick: () => this.setState({
        open: false
      })
    }, /*#__PURE__*/React.createElement("b", null, it.label), /*#__PURE__*/React.createElement("span", null, it.sub)))));
  }
}

/** The Email section header: title, one line, extra actions (optional) + New, then the tabs. */
export function EmailHeader({
  actions,
  chips
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: "Email",
    subtitle: EMAIL_SUBTITLE,
    chips: chips || [],
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, /*#__PURE__*/React.createElement(NewEmailMenu, null))
  }), /*#__PURE__*/React.createElement(Switcher, {
    items: emailViews(),
    ariaLabel: "Email views"
  }));
}